import React from 'react';
import ReactDOM from 'react-dom';
import 'semantic-ui-css/semantic.min.css'
import './index.css';
import MainRouter from "./MainRouter";

ReactDOM.render(
    <MainRouter />,
    document.getElementById('root')
);